import React, { Fragment } from 'react'
import RoomSchedule from 'frontend/schedule/room-schedule'
import PlayersCountButtons from 'frontend/schedule/players-count-buttons'
import PlayersCountInput from 'frontend/schedule/players-count-input'
import MinPriceIndicator from 'frontend/schedule/min-price-indicator'
import RoomWeekSelect from 'frontend/schedule/room-week-select'

import DiscontImageWebP from 'pages/rooms/casino_heist/schedule/book-advance-banner/discount.webp'
import DiscontImagePng from 'pages/rooms/casino_heist/schedule/book-advance-banner/discount.png'

import BannerImageWebP from 'pages/rooms/casino_heist/schedule/book-advance-banner/image.webp'
import BannerImagePng from 'pages/rooms/casino_heist/schedule/book-advance-banner/image.png'

export default class extends RoomSchedule {
  renderFilters() {
    return (
      <div className="filters">
        <div className="select_date">
          <h4 className="title">
            <span className="fix_title">1. Select date and time</span>
          </h4>
          <RoomWeekSelect
            selected={this.state.selectedDate}
            onChange={this.handleDateSelect.bind(this)}
          />
        </div>
        <div className="filters__divider"></div>
        <div className="select_players_count">
          <h4 className="title">
            <span className="fix_title">2. Select number of players</span>
          </h4>
          <PlayersCountButtons
            playersWithMinPrices={this.state.schedule.minPriceByPlayersCount}
            selected={this.state.selectedPlayersCount}
            onSelect={this.handlePlayersCountSelect.bind(this)}
          />
          <div className="players_count_input_with_price_indicator">
            <PlayersCountInput
              minPlayers={this.state.schedule.minPlayers}
              maxPlayers={this.state.schedule.maxPlayers}
              value={this.state.selectedPlayersCount}
              onChange={this.handlePlayersCountSelect.bind(this)}
            />
            <MinPriceIndicator
              playersCount={this.state.selectedPlayersCount}
              playersWithMinPrices={this.state.schedule.minPriceByPlayersCount}
            />
          </div>
        </div>
        {this.renderAdvanceDiscountBanner()}
      </div>
    )
  }

  renderAdvanceDiscountBanner() {
    return (
      <div className="book-advance-banner">
        <div className="book-advance-banner__content-container">
          Book 7 days in advance
          <picture className="book-advance-banner__discount-container">
            <source type="image/webp" title="Decorate image" srcSet={DiscontImageWebP} />
            <img
              width="121"
              height="36"
              className="book-advance-banner__discount"
              alt="Save $10"
              src={DiscontImagePng}
            />
          </picture>
        </div>
        <picture className="book-advance-banner__image-container">
          <source type="image/webp" title="Decorate image" srcSet={BannerImageWebP} />
          <img width="141" height="36" className="book-advance-banner__image" alt="Save $10" src={BannerImagePng} />
        </picture>
      </div>
    )
  }

  renderPriceLegend() {
    const tiers = this.state.schedule.minPriceByType?.slice().sort((a, b) => a.price - b.price)
    if (!tiers) return null
    return (
      <Fragment>
        <div className="price-legend">
          {tiers.map((tier, index) => {
            return (
              <div className="price-legend__item" key={index}>
                <span className="price-legend__value">
                  $
                  {tier.price}
                </span>
                <span className="price-legend__note">
                  {' '}
                  / person
                  {' '}
                  {tier.legend.toLowerCase()}
                </span>
              </div>
            )
          })}
        </div>
        <div className="price-legend price-legend--hot-fix">
          <span className="price-legend__note">2 and 3 players pay the same price on Weekends</span>
        </div>
      </Fragment>
    )
  }

  renderScheduleBlocks() {
    return (
      <Fragment>
        {this.renderPriceLegend()}
        {this.renderFilters()}
        {this.renderSchedule()}
        {this.renderViewFullWeekButtonMaybe()}
      </Fragment>
    )
  }
}
